import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ResourceAppResource from './ResourceAppResource';
import WorkspaceTypeAppResource from './WorkspaceTypeAppResource';
import ProjectBillboardAppResource from "./ProjectBillboardAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";

export const BILLBOARDS = {
    PRE_QUALIFIED_MORTGAGE_HP: 'pre-qualified-mortgage-home-purchase',
    BUY_BEFORE_YOU_SELL_HP: 'buy-before-you-sell-home-purchase',
    HOMEOWNER_INSURANCE: 'get-homeowner-insurance',
    HOME_WARRANTY: 'get-a-home-warranty',

    QA_HP: 'qa-home-purchase',
    SEARCH_PROPERTIES_HP: 'search-properties-home-purchase',
    HIRE_ATTORNEY_HP: 'hire-attorney-home-purchase',
    TITLE_AND_ESCROW_HP: 'title-and-escrow-home-purchase',
    LIFE_EVENT_HP: 'life-event-home-purchase',

    QA_HS: 'qa-home-sale',
    BASICS_SELLING_HOME_HS: 'basics-selling-home-home-sale',
    HOME_VALUATION_HS: 'home-valuation-estimate-home-sale',

    CHECK_OUT_SERVICES: 'check-out-services-home-ownership',
    SETTING_UP_HUB: 'setting-up-hub-home-ownership',
    LIFE_EVENTS_HOME_OWNERSHIP: 'life-events-home-ownership',
};

export const LEARN_MORE_TYPES = {
    TAG: 'tag',
    ARTICLE: 'article',
};

class BillboardAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'billboard';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'billboards';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'description',
            'actionTitle',
            'slug',
            'projectTypeUuid',
            'resourceUuid',
            'canResume',
            'sort',
            'projectType',
            'resource',
            'projectBillboards',
            'projects',
            'secondaryActionTitle',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            projectType: WorkspaceTypeAppResource,
            resource: ResourceAppResource,
            projectBillboards: ProjectBillboardAppResource,
            projects: WorkspaceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            projectType: 'project_type_uuid',
            resource: 'resource_uuid',
            projectBillboards: 'billboard_uuid',
            projects: 'billboard_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 10000,
                },
            },
            actionTitle: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            secondaryActionTitle: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            projectTypeUuid: {
                type: 'string',
                presence: true,
            },
            resourceUuid: {
                type: 'string',
            },
            canResume: {
                type: 'boolean',
            },
            sort: {
                presence: true,
                numericality: true,
            },
        };
    }

}

export default BillboardAppResource;
